import React, { useState } from "react";
import axios from "axios";
import "./Ignite.css";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
const Ignite = () => {
  const location = useLocation();

    useEffect(() => {
      if (location.hash) {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }
    }, [location]);
  useEffect(() => {
  window.scrollTo({ top: 0, behavior: "smooth" });
}, []);
  const [waitlistData, setWaitlistData] = useState({
    name: "",
    email: "",
    phone: "",
    sport: "",
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setWaitlistData({
      ...waitlistData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post("/join-waitlist", waitlistData);
      setMessage("Successfully joined the waitlist!");
      setWaitlistData({
        name: "",
        email: "",
        phone: "",
        sport: "",
      });
    } catch (error) {
      setMessage("Error joining waitlist.");
    }
  };

  return (
    <main className="ignite-page">
      {/* HERO CARD */}
      <section className="v2-section ignite-hero-section">
        <div className="v2-container ignite-hero">
          <div className="ignite-hero-left">
            <div className="ignite-badge">
              FYP – IGNITE  • <span>COMING SOON</span>
            </div>
            <h1 className="ignite-title">Build Your Competitive Edge.</h1>
            <p className="ignite-sub">
              Ignite is our next-level performance program after Bootcamp —
              built around the 5 pillars athletes need most: <strong>Vision</strong>,
              <strong> Hand Eye</strong>, <strong>Memory</strong>,
              <strong> Anticipation</strong>, and <strong>Sleep</strong>.
            </p>
            <div className="ignite-cta-row">
              <a className="ignite-primary" href="#waitlist">
                Join the Waitlist
              </a>
              <a className="ignite-secondary" href="#ignite-included">
                See What’s Included
              </a>
            </div>
            <p className="ignite-footnote">
              Limited cohort seats • Weekly structure • Built for serious athletes
            </p>
          </div>
          <div className="ignite-hero-right" aria-hidden="true">
            <img src="/FYP-Ignite/Hero.png" alt="FYP Ignite hero" />
          </div>
        </div>
      </section>

      {/* 5 PILLARS */}
      <section className="v2-section ignite-pillars-section">
        <div className="v2-container ignite-card ignite-pillars-card">
          <h2 className="ignite-h2">5 Pillars of Ignite</h2>
          <p className="ignite-note">
            Each pillar has a clear training focus and on-field transfer outcome.
          </p>
          <div className="ignite-pillars">
            <div className="ignite-pillar">
              <h4>Vision</h4>
              <p>Clarity, tracking, depth, and focus control under speed.</p>
            </div>
            <div className="ignite-pillar">
              <h4>Hand Eye</h4>
              <p>Timing, contact quality, and exact coordination loops.</p>
            </div>
            <div className="ignite-pillar">
              <h4>Memory</h4>
              <p>Pattern retention, recall speed, and decision stability.</p>
            </div>
            <div className="ignite-pillar">
              <h4>Anticipation</h4>
              <p>Earlier pickup of cues and improved prediction accuracy.</p>
            </div>
            <div className="ignite-pillar">
              <h4>Sleep</h4>
              <p>Recovery protocols that protect speed, learning, and consistency.</p>
            </div>
          </div>
        </div>
      </section>

      {/* WHAT'S INCLUDED */}
      <section className="v2-section ignite-included-section">
        <div className="v2-container">
          <div
            className="ignite-card ignite-included-card"
            id="ignite-included"
          >
            <h2 className="ignite-h2">What’s Included</h2>
            <p className="ignite-note">
              A simple, structured stack: foundation → step courses → weekly
              coaching → community.
            </p>

            <div className="ignite-included">
              <div className="ignite-inc-card">
                <span className="num">1</span>
                <div>
                  <h4>Foundation: Neural Performance Core</h4>
                  <p>Upgrade the Brain Behind the Performance.</p>
                </div>
              </div>

              <div className="ignite-inc-card">
                <span className="num">2</span>
                <div>
                  <h4>Pillar Mini-Courses</h4>
                  <p>
                    Short, focused step-by-step courses for Vision, Hand-Eye,
                    Memory, Anticipation, and Sleep.
                  </p>
                </div>
              </div>

              <div className="ignite-inc-card">
                <span className="num">3</span>
                <div>
                  <h4>Performance-athon (Hackathon Weeks)</h4>
                  <p>
                    Live sprint weeks where you learn, troubleshoot, and level
                    up with the group.
                  </p>
                </div>
              </div>

              <div className="ignite-inc-card">
                <span className="num">4</span>
                <div>
                  <h4>Inner Circle Weekly Coaching</h4>
                  <p>
                    Weekly sessions for accountability, corrections, and steady
                    progress.
                  </p>
                </div>
              </div>

              <div className="ignite-inc-card">
                <span className="num">5</span>
                <div>
                  <h4>Private Community Access</h4>
                  <p>
                    Support, check-ins, and guidance to stay consistent and
                    motivated.
                  </p>
                </div>
              </div>

              <div className="ignite-inc-card">
                <span className="num">6</span>
                <div>
                  <h4>Progress Direction (Coming Soon)</h4>
                  <p>
                    Larger measurement snapshots to track improvement over time.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WAITLIST */}
      <section className="v2-section" id="waitlist">
        <div className="v2-container ignite-waitlist">
          <div className="ignite-wl-left">
            <h3>Join the Ignite Waitlist</h3>
            <p>
              Be the first to know when the cohort opens. Early waitlist members
              get priority access.
            </p>
          </div>

          <form className="ignite-wl-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Full Name"
              value={waitlistData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={waitlistData.email}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="phone"
              placeholder="Phone Number"
              value={waitlistData.phone}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="sport"
              placeholder="Sport (e.g., Cricket)"
              value={waitlistData.sport}
              onChange={handleChange}
            />
            <button className="ignite-primary" type="submit">
              Join Waitlist
            </button>
            <small className="ignite-privacy">
              No spam. Only cohort updates.
            </small>
            {message && <p>{message}</p>}
          </form>
        </div>
      </section>

      <footer className="ignite-footer">
        <div className="v2-container">
          <small>
            © ForgeYourPeak — FYP – Ignite  • Coming Soon
          </small>
        </div>
      </footer>
    </main>
  );
};

export default Ignite;